/* global jQuery, accessoryShopMiniCartObj */
import { accessoryStorageGet, accessoryStorageSet } from "app/React/Helpers/AccessoryStorageHelper";

export default class AccessoryShopMiniCart {
  cartFlashDuration = 3000
  miniCartLink
  miniCartContainer
  miniCartIndicatorContainer
  miniCartItemsContainer
  miniCartTotalContainer
  cartItems
  cartTimeout

  ready() {
    window.addEventListener(
      'storage', () => {
        this.updateCartItems(accessoryStorageGet('cart-items') ?? [])
        this.flashCart()
      },
      false
    )

    this.setup()
  }

  setup() {
    this.miniCartLink = jQuery('.main-navigation__icon.cart > a')
    this.miniCartContainer = jQuery('.mtt-mini-cart')
    this.miniCartIndicatorContainer = jQuery('.mtt-mini-cart-qty')
    this.miniCartItemsContainer = this.miniCartContainer.find('.mtt-mini-cart__items')
    this.miniCartTotalContainer = this.miniCartContainer.find(
      '.mtt-mini-cart__totals-price .mtt-mini-cart__totals-header'
    )

    const CART_ITEMS = this.getCartItemsFromStorage()
    this.updateCartItems(CART_ITEMS)

    this.miniCartContainer.on('click', '.mtt-mini-cart__item-price-wrapper', this.handleRemoveClick.bind(this))
  }

  updateCartItems(cartItems) {
    this.cartItems = cartItems
    this.loadCartItems(cartItems)
    this.loadTotal(cartItems)
    this.loadQuantity(cartItems)
    this.setCartIconLink(cartItems)
  }

  handleRemoveClick(e) {
    e.preventDefault()

    const cartItem = jQuery(e.currentTarget).closest('.mtt-mini-cart__item')
    const cartItemId = parseInt(cartItem.attr('data-accessory-id'))
    const newCartItems = this.cartItems.filter((item) => item.id !== cartItemId)

    accessoryStorageSet('cart-items', newCartItems)
  }

  getCartItemsFromStorage() {
    return accessoryStorageGet('cart-items') ?? []
  }

  loadCartItems(cartItems) {
    const THAT = this
    cartItems = cartItems.map((accessory) => {
      return THAT.getCartItemRowMarkup(accessory)
    })

    this.miniCartItemsContainer.html(cartItems)
  }

  flashCart() {
    this.miniCartContainer.addClass('mtt-mini-cart--show')
    clearTimeout(this.cartTimeout)
    this.cartTimeout = window.setTimeout(() => {
      this.miniCartContainer.removeClass('mtt-mini-cart--show')
    }, this.cartFlashDuration)
  }

  loadTotal(cartItems) {
    let total = 0

    cartItems.forEach((accessory) => {
      total += accessory.price.raw
    })

    const currency = window.accessoryShopMiniCartObj.strings.currency
    const FORMATTED_TOTAL = Intl.NumberFormat('da-DK').format(total) + ' ' + currency

    this.miniCartTotalContainer.html(FORMATTED_TOTAL)
  }

  loadQuantity(cartItems) {
    if (cartItems.length === 0) {
      this.miniCartContainer.addClass('hidden')
      this.miniCartIndicatorContainer.addClass('hidden')
      return
    }

    this.miniCartIndicatorContainer.html(cartItems.length)
    this.miniCartContainer.removeClass('hidden')
    this.miniCartIndicatorContainer.removeClass('hidden')
  }

  getCartItemRowMarkup(accessory) {
    let cartItemRowMarkup = window.accessoryShopMiniCartObj.miniCart.rowMarkup

    cartItemRowMarkup = cartItemRowMarkup.replace('{{id}}', accessory.id)
    cartItemRowMarkup = cartItemRowMarkup.replace('{{image}}', accessory.image)
    cartItemRowMarkup = cartItemRowMarkup.replace('{{title}}', accessory.title)
    cartItemRowMarkup = cartItemRowMarkup.replace('{{short_models_name}}', accessory.short_models_name.join(', '))
    cartItemRowMarkup = cartItemRowMarkup.replace('{{price}}', accessory.price.formatted)

    return cartItemRowMarkup
  }

  setCartIconLink(cartItems) {
    const paymentLink = window.accessoryShopMiniCartObj.miniCart.paymentLink
    const shopLink = window.accessoryShopMiniCartObj.miniCart.shopLink
    const link = cartItems?.length > 0 ? paymentLink : shopLink
    this.miniCartLink.attr('href', link)
  }
}
